module.exports = __webpack_public_path__ + "img/distribution-miniprogram-code.7d8dd2f.png";